import { getToken, setToken } from 'public/utils'
import Router from '../../router'
import store from 'public/store'

/*
  自动登录逻辑
*/

let tokenChannel = null // 自动登录的消息通道

const TOKEN_CHANNEL = 'kye_token_channel' // 发送token的标识
const REQUEST_TOKEN = 'kye_request_token' // 请求发送token的标识
const KEY_TOKEN = 'kye_token' // 接收Token时的标识


/**
 *
 * @description 创建Token的广播
 * @export
 * @param {*} params
 */
export function createAutoLoginChannel() {
  try {
    if (!tokenChannel) {
      tokenChannel = new BroadcastChannel(TOKEN_CHANNEL)
    }
    requestTokenIfNeeded()
  } catch (e) {
    console.error('创建广播时发生错误:', e)
  }
}

/**
 *
 * @description 发送初始请求Token的消息
 */
export function requestTokenIfNeeded() {
  try {
    tokenChannel.postMessage({ type: REQUEST_TOKEN })
    tokenChannel.addEventListener('message', event => {
      if (event.data.type === REQUEST_TOKEN) {
        let token = getToken()
        if (token) {
          // 再次发送消息，新打开的不会接收,但是自身会被接收
          sendTokenChannelMessage(token)
        }
      }
    })
  } catch (error) {
    console.error('发送初始请求令牌消息时发生错误:', error)
  }
}

/**
 *
 * @description 发送Token的消息
 */
function sendTokenChannelMessage(token) {
  try {
    tokenChannel.postMessage({ type: KEY_TOKEN, value: token })
  } catch (error) {
    console.error('发送初始请求令牌消息时发生错误:', error)
  }
}

/**
 *
 * @description 创建接收Token广播的回调
 * @export
 * @param {*} channelMessageCallback
 */
export function handleReceivedTokenMessaage(params) {
  tokenChannel.addEventListener('message', event => {
    // // 新的窗口开始接收token
    if (event.data.type === KEY_TOKEN) {
      const token = getToken() || event.data.value
      // 如果没有就不做处理
      if (!token) {
        return
      }
      // 这里还有一个场景,由于广播一直存在，所以接收的消息，可能不存在 oldPath
      const oldPath = store.state.oldPath
      if (oldPath.indexOf('autologin=true') > -1) {
        setToken(event.data.value)
        params.channelMessageCallback && params.channelMessageCallback()
        Router.push({ path: oldPath, replace: true })
      }
    }
  })
}


// 创建自动登录消息频道广播
createAutoLoginChannel()



// WEBPACK FOOTER //
// ./src/layout/layout/setup/login.js